import { apiService } from './api';
import { getUserInfo } from '../utils/auth';

export const BlogService = {

  getAllBlogCategory: async () => {
    try {
      const response = await apiService.get('/Category/blogs');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch categories');
    }
  },
   searchBlogs: async (query) => {
    try {
      const response = await apiService.get(`/blogs/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Failed to search tutorials:', error);
      throw error;
    }
  },

  getHomeBlogs: async () => {
    try {
      const response = await apiService.get('/blogs/home');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch posts');
    }
  },

    getBlogsSummery: async () => {
    try {
      const response = await apiService.get('/blogs/summary');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch posts');
    }
  },

  getBlogsByCategory: async (id) => {
    try {
      const response = await apiService.get(`/blogs/category/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post content');
    }
  },

   getPostWithContent: async (id) => {
    try {
      const response = await apiService.get(`/post/contents/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch post content');
    }
  },

};
